// extracted by css-extract-rspack-plugin
export default {"adBlockWrap":"y7qPE","adBlock":"vgekH"};